import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4057 2.6462C12.5839 1.98862 11.4161 1.98862 10.5943 2.6462L2.53144 9.09773C2.35372 9.23993 2.25 9.45532 2.25 9.68336V19.4999C2.25 20.7425 3.25736 21.7499 4.5 21.7499H19.5C20.7426 21.7499 21.75 20.7425 21.75 19.4999V10.4042C21.75 9.72077 21.4394 9.07438 20.9057 8.64739L13.4057 2.6462ZM6.50826 13.4485C6.20367 13.1678 5.72919 13.1871 5.44849 13.4917C5.16778 13.7963 5.18715 14.2708 5.49174 14.5515C6.97365 15.9172 9.37066 16.75 12 16.75C14.6293 16.75 17.0264 15.9172 18.5083 14.5515C18.8129 14.2708 18.8322 13.7963 18.5515 13.4917C18.2708 13.1871 17.7963 13.1678 17.4917 13.4485C16.3524 14.4984 14.3526 15.25 12 15.25C9.64745 15.25 7.64758 14.4984 6.50826 13.4485Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
